"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwitterWidget = TwitterWidget;
var jsx_runtime_1 = require("react/jsx-runtime");
function TwitterWidget(_a) {
    var url = _a.url;
    return ((0, jsx_runtime_1.jsx)("blockquote", { className: "twitter-tweet", children: (0, jsx_runtime_1.jsx)("a", { href: url }) }));
}
